import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { FaFilePdf } from "react-icons/fa";

export default function CourseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("description");
  const [course, setCourse] = useState(null);
  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    const fetchCourse = async () => {
      const userData = JSON.parse(localStorage.getItem("userDataLogin"));
      const token = userData?.token;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/payment_course/${id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "Accept-Language": i18n.language,
            },
          }
        );


        const data = await response.json();

        if (data.data?.type === "free" || data.data?.purshed === 1) {
          setCourse(data.data);
        } else if (data.redirect_url) {
          window.location.href = data.redirect_url;
        } else {
          toast.error(data.message || "Something went wrong");
        }
      } catch (error) {
        toast.error(error.message || "Something went wrong");
      }
    };

    fetchCourse();
  }, [id, i18n.language]);

  if (!course) return null;
  console.log(course)

  const videosToDisplay =
    Array.isArray(course?.video) && course.video.length > 0
      ? course.video
      : [];

  return (
    <>
      <div className="custom-section">
        <div className="container">
          <h1 className="m-0">{t("courses.details")}</h1>
          <h6 className="m-0">
            <Link className="link-hover" to="/">
              {t("courses.home")}
            </Link>
            <span> - </span>
            <Link className="link-hover" to="/courses">
              {t("courses.title")}
            </Link>
            <span> - </span>
            <span className="second-color">{t("courses.details")}</span>
          </h6>
        </div>
      </div>

      <section className="mt-3 mb-1">
        <div className="course-container">
          <h1 className=" main-color  " style={{ fontSize: "27px" }}>
            {course?.name}
          </h1>
          <div className="course-image">
            <img src={JSON.parse(course?.image)[0]} style={{ width: "300px", maxWidth: "100%" }} alt="Course" />
          </div>

          <div className="d-flex flex-wrap justify-content-between align-items-center mt-4">
            <ul className="course-tabs mb-3">
              <li
                className={`tab-item ${activeTab === "description" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("description")}
              >
                {t("courses.description")}
              </li>
              <li
                className={`tab-item ${activeTab === "resources" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("resources")}
              >
                {t("courses.resources")}

              </li>
            </ul>
            <a href={course.link_zoom} target="_blank" rel="noopener noreferrer">
              <h4 className="zoomlive m-0">Zoom Live</h4>
            </a>
          </div>

          <h1 className="main-color mt-3 ">
            Course Overview
          </h1>

          <div className="course-content">
            <p
              className={`tab-content  main-color ${activeTab === "description" ? "active" : ""
                }`}
            >
              {course.description}
            </p>

            <div className={`tab-content text-center text-md-start main-color ${activeTab === "resources" ? "active" : ""}`}>
              {course.file ? (
                <a
                  key={course.id}
                  href={JSON.parse(course.file)[0]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center justify-content-between border-bottom p-3 text-decoration-none"
                >
                  <div className="d-flex align-items-center gap-2">
                    <FaFilePdf color="red" size={20} />
                    <span>{course.name}</span>
                  </div>
                  <span className="text-success">{t('download')}</span>
                </a>
              ) : (
                "No resources available."
              )}
            </div>

          </div>
        </div>
      </section>

      <section>
        <div className="container ">
          <div className="row justify-content-center">
            {course.instructors?.map((instructor, index) => (
              <div
                className="col-lg-6 col-md-6 col-12 d-flex justify-content-center"
                key={index}
              >
                <div>
                  <h4 className="main-color text-center">Instructors</h4>
                  <div
                    style={{ width: "300px", maxWidth: "100%" }}
                    className="card p-3"
                  >
                    <img
                      src={instructor.image}
                      className="card-img-top"
                      alt={instructor.name}
                    />
                    <div className="card-body">
                      <h5 className="card-title fw-bold main-color text-center">
                        {instructor.name}
                      </h5>
                      <p className="card-text paragraph-color text-center">
                        {course.stage}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-5">
            <div className="row">
              <h1 className="text-center my-2 mb-3" style={{fontSize : "25px"}}>{t('courseVideo')}</h1>
              {videosToDisplay.length > 0 && videosToDisplay.map((videoUrl, index) => (
                console.log(videoUrl),
                <div className="col-md-4 mb-4" key={index}>
                  <div className="card custom-card">
                    <div className="ratio ratio-16x9">
                      <iframe
                        width="560"
                        height="315"
                        src={videoUrl.src}
                        title={`YouTube video ${index + 1}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
